import React from "react";
import "./NewBanner.scss";
import hero5 from "../../public/images/hero5-app.png";
import { Col, Row } from "antd";
import { useSelector } from "react-redux";
import ar from "../../public/localization/ar";
import en from "../../public/localization/en";
import { AiFillApple } from "react-icons/ai";
import { SiHuawei } from "react-icons/si";
import { FaGooglePlay } from "react-icons/fa";
import { AiOutlineWhatsApp } from 'react-icons/ai';


export default function OfferBanner() {
  const { currentLang } = useSelector((state) => state?.entities?.user);
  const t = currentLang === "ar" ? ar : en;

  return (
    <section className="banner-section-wrapper">
      <div className="background-image-wraper"></div>
      <div className="hero-bottom-shape-two"></div>
      <div className="container">
        <Row className="banner-text-content">
          <Col xs={24} lg={12}>
            <div className="hero-slider-content glass text-white py-5">
              <h1 className="text-white">{t.Chauffeurapp}</h1>
              <p className="lead">{t.bannerChauffeur}</p>
              {/* <div
                style={{
                  maxWidth: '480px',
                  margin: '2rem',
                  padding: '2.5rem',
                  color: '#fff',
                  background: 'rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  borderRadius: '16px',
                }}
              >
                <h1 style={{
                  fontSize: '6rem',
                  fontWeight: 700,
                  lineHeight: 1.2,
                  margin: 0
                }}>
                  UNLIMITED<br />
                  HOME DELIVERIES
                </h1>

                <p style={{
                  marginTop: '0.5rem',
                  fontSize: '2.5rem'
                }}>
                  Across Emirates at a Limited Price
                </p>
                <br />
                <br />
                <div style={{ margin: '1.5rem 0' }}>
                  <div style={{
                    fontSize: '2.6rem',
                    marginBottom: '0.7rem'
                  }}>
                    Just in{' '}
                    <span style={{
                      background: '#4A2E6B',
                      color: '#fff',
                      padding: '0.3em 0.8em',
                      borderRadius: '8px',
                      fontWeight: 700,
                      fontSize: '2.4rem'
                    }}>
                      AED 1000
                    </span>
                    /month
                  </div>

                  <div style={{
                    fontStyle: 'italic',
                    fontSize: '2.2rem',
                    marginBottom: '1rem'
                  }}>
                    Unlock exclusive delivery benefits tailored for your business.
                  </div>
                  <br />
                  <br />
                  <a
                    href="https://wa.me/+971544462611?text=I%27m%20interested"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      background: '#4A2E6B',
                      color: '#fff',
                      padding: '0.5em .7em',
                      borderRadius: '999px',
                      fontWeight: 700,
                      textDecoration: 'none',
                      fontSize: '2.2rem',
                      boxShadow: '0 2px 8px rgba(74,46,107,0.15)'
                    }}
                  >
                    <AiOutlineWhatsApp style={{ marginRight: '0.5em', fontSize: '3rem' }} />
                    Chat on WhatsApp
                  </a>

                  <div style={{
                    marginTop: '1rem',
                    fontSize: '2rem',
                    fontWeight: 400
                  }}>
                    Offer valid till 31st May
                  </div>
                </div>
              </div> */}
              {/* <div className="img-wrap">
                <img src={QRCode} alt="wa" />
              </div> */}
              <div className="action-btns mt-4">
                <ul className="list-inline">
                  <li className="list-inline-item">
                    <a
                      href="https://apps.apple.com/eg/app/chauffeur-hub/id1637732187"
                      target="_blank"
                      className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                      rel="noreferrer"
                    >
                      <AiFillApple />

                      <div className="download-text">
                        <small>{t.Downloadfrom}</small>

                        <h5 className="mb-0">{t.AppleStore}</h5>
                      </div>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://play.google.com/store/apps/details?id=com.nativetech.chauffeur"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                    >
                      <FaGooglePlay />
                      <div className="download-text">
                        <small>{t.Downloadfrom}</small>

                        <h5 className="mb-0">{t.GooglePlay}</h5>
                      </div>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://appgallery.huawei.com/app/C108194919"
                      target="_blank"
                      rel="noreferrer"
                      className="d-flex align-items-center app-download-btn btn btn-brand-02 btn-rounded"
                    >
                      <SiHuawei />

                      <img
                        className="mr-3"
                        src="assets/img/icons8-huawei-logo-26.png"
                        alt=""
                      />
                      <div className="download-text">
                        <small>{t.Downloadfrom}</small>

                        <h5 className="mb-0">{t.AppGallery}</h5>
                      </div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={24} lg={12}>
            <div className="img-wrap" style={{ paddingTop: '5rem' }}>
              <img
                src={hero5}
                alt="Shipping and shopping platform UAE"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}
